"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var LocalDateRender = /** @class */ (function (_super) {
    __extends(LocalDateRender, _super);
    function LocalDateRender() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shimLocals = function () {
            var lng = _this.props.lng;
            return lng.includes('zh') ? 'zh-cn' : lng;
        };
        return _this;
    }
    LocalDateRender.prototype.render = function () {
        var _a = this.props, value = _a.value, outputFormat = _a.outputFormat, inputFormat = _a.inputFormat, fromNow = _a.fromNow, timezone = _a.timezone;
        var date = inputFormat ? moment_timezone_1.default(value, inputFormat) : moment_timezone_1.default(value);
        date.locale(this.shimLocals());
        if (timezone) {
            date.tz(timezone);
        }
        if (!fromNow) {
            return date.format(outputFormat);
        }
        else {
            return date.fromNow();
        }
    };
    return LocalDateRender;
}(react_1.Component));
exports.default = LocalDateRender;
